import { useQueryClient } from '@tanstack/react-query';
import { getRepositoryQueryKey } from '@mews-commander/data-access';

export const useBillsQueryInvalidation = () => {
    const queryClient = useQueryClient();

    return () => {
        void queryClient.invalidateQueries({
            queryKey: getRepositoryQueryKey('bills', 'getAll'),
        });
    };
};
